module.exports = __webpack_public_path__ + "img/petra.857a31f0.png";